import { GET_PROJECT_COMMODITY_TYPES } from '@bechtel/client-gql';

export const CommodityTypeListRequest = {
  query: GET_PROJECT_COMMODITY_TYPES,
};

export const CommodityTypeListResponse = {
  data: {
    projectConfigById: {
      id: '1',
      projectCommodityTypes: [
        {
          id: 1,
          name: 'Spool',
        },
        {
          id: 2,
          name: 'Underground Spool',
        },
        {
          id: 3,
          name: 'Bulk pipe',
        },
        {
          id: 4,
          name: 'Underground Bulk pipe',
        },
        {
          id: 5,
          name: 'Weld',
        },
        {
          id: 6,
          name: 'Hanger',
        },
        {
          id: 7,
          name: 'Socket Weld',
        },
        {
          id: 8,
          name: 'Large Bore',
        },
      ],
    },
  },
};
export const CommodityTypeListMockData = {
  request: CommodityTypeListRequest,
  result: CommodityTypeListResponse,
};
